/**
 * Turn an axios error into the sentence the user should read.
 *
 * The API answers a failed write in four different shapes and the call sites used to
 * pick one each, so the same failure read differently depending on where it happened:
 *
 *   - `{error: '...'}`     — this project's own key, raised deliberately by a view
 *   - `{detail: '...'}`    — every DRF APIException: 401, 403, 404, throttling
 *   - `{field: ['...']}`   — a serializer validation error, keyed by field
 *   - nothing at all       — a 500, where the body is an HTML traceback page
 *
 * Reading only `error` (the old habit) rendered an expired session, a permission
 * failure and a server crash as the same blank fallback, which is exactly how a
 * reproducible bug reaches a developer with no information attached to it.
 *
 * @param {object} e - the axios error
 * @param {string} fallback - used only when the error carries nothing at all
 * @returns {string}
 */
export function apiErrorMessage(e, fallback = 'Please try again.') {
  const data = e?.response?.data;
  return data?.error
    || data?.detail
    || Object.values(data || {})?.[0]?.[0]
    || (e?.response?.status ? `HTTP ${e.response.status}` : e?.message)
    || fallback;
}
